module.exports = __webpack_public_path__ + "static/media/invite_interpreters.b25b87b6.svg";